const DEFAULT_MESSAGE =
  'This student already has an active session. Resume it or end it before starting another.';

/**
 * The learner-facing half of `useActiveSessionConflict`: the two choices an
 * ACTIVE_SESSION_EXISTS 409 must always offer, in identical wording, wherever a
 * session can be created. Renders nothing when there is no conflict.
 */
function ActiveSessionConflictPrompt({
  conflict,
  isResolving = false,
  onResume,
  onEndAndStartNew,
  titleId = 'active-session-conflict-title',
  className = 'card',
}) {
  if (!conflict) {
    return null;
  }

  return (
    <section className={className} role="dialog" aria-modal="false" aria-labelledby={titleId}>
      <div className="section-header">
        <div>
          <p className="eyebrow">Already in a session</p>
          <h2 id={titleId}>You already have an active session</h2>
        </div>
      </div>
      <p className="practice-intro-copy">{conflict.message || DEFAULT_MESSAGE}</p>
      <div className="practice-resume-actions">
        <button
          type="button"
          className="btn btn-primary"
          onClick={onResume}
          disabled={isResolving}
        >
          Resume existing session
        </button>
        <button
          type="button"
          className="btn btn-secondary"
          onClick={onEndAndStartNew}
          disabled={isResolving}
        >
          {isResolving ? 'Ending session...' : 'End it and start a new session'}
        </button>
      </div>
    </section>
  );
}

export default ActiveSessionConflictPrompt;
